import { createElement } from 'react';

import IconDeepResearchText from '@components/Images/DeepResearch/IconDeepResearchText';
import {
  CHARTS_AND_DATA_LIBRARY_IMAGE_URL,
  EXCLUSIVE_REPORTING_IMAGE_URL,
  NEWSLETTERS_IMAGE_URL,
} from '@components/pages/DualSubscribe/constants';
import type { BenefitRow } from '@components/pages/SubscribeTest/interfaces';
import { IMGIX_URL } from '@src/env';

import { CompanyLogo } from '../OfferSelection/TheInformationPro/Companies';

export const THE_INFORMATION_DIFFERENCE = 'The Information Difference';

export const MONTHLY = 'Monthly';

export const BENEFITS = [
  {
    name: createElement(IconDeepResearchText, { className: 'deep-research-logo' }),
    eligibility: [false, false, true],
  },
  {
    name: createElement(
      'span',
      { className: 'flex items-center gap-4' },
      'Daily streaming show',
      createElement('span', { className: 'text-primary-magenta font-medium' }, 'TITV')
    ),
    eligibility: [true, true, true],
  },
  { name: 'All of our award-winning journalism', eligibility: [true, true, true] },
  {
    name: createElement(
      'span',
      { className: 'flex items-center gap-4' },
      '8+ newsletters',
      createElement('span', { className: 'font-light' }, '(AI deep dives and more)')
    ),
    eligibility: [true, true, true],
  },
  { name: 'Charts and data library', eligibility: [true, true, true] },
  { name: 'The Information app', eligibility: [true, true, true] },
  { name: 'The Information Polls', eligibility: [true, true, true] },
  { name: 'Audio: listen to our articles', eligibility: [false, true, true] },
  { name: 'Community networking tools', eligibility: [true, true, true] },
  { name: 'Library of 60+ company org charts', eligibility: [false, false, true] },
  { name: '12 Proprietary Databases', eligibility: [false, false, true] },
  { name: 'Subscriber survey results', eligibility: [false, false, true] },
];

export const companies: CompanyLogo[] = [
  {
    name: 'Apple',
    className: 'h-[25px] w-[20px] sm:h-[28px] sm:w-[23px]',
    path: `${IMGIX_URL}/global/subscribe/Apple_White_Logo.png`,
  },
  {
    name: 'Google',
    className: 'h-[19px] w-[56px] sm:h-[22px] sm:w-[65px]',
    path: `${IMGIX_URL}/global/subscribe/Google_White_Logo.png`,
  },
  {
    name: 'Microsoft',
    className: 'h-[20px] w-[93px] sm:h-[23px] sm:w-[107px]',
    path: `${IMGIX_URL}/global/subscribe/Microsoft_White_Logo.png`,
  },
  {
    name: 'Meta',
    className: 'h-[12px] w-[59px] sm:h-[15px] sm:w-[74px]',
    path: `${IMGIX_URL}/global/subscribe/Meta_White_Logo.png`,
  },
  {
    name: 'Nvidia',
    className: 'h-[16px] w-[87px] sm:h-[19px] sm:w-[97px]',
    path: `${IMGIX_URL}/global/subscribe/Nvidia_White_Logo.png`,
  },
  {
    name: 'Amazon',
    className: 'h-[17px] w-[56px] sm:h-[20px] sm:w-[66px]',
    path: `${IMGIX_URL}/global/subscribe/Amazon_White_Logo.png`,
  },
];

export const BENEFIT_ROWS: BenefitRow[] = [
  {
    title: 'Focus on Exclusive Reporting',
    paragraphs: [
      'The Information’s newsroom is focused on tech, AI and finance, meaning you get specialized coverage of each industry by reporters who are experts in their respective topics.',
      'Our editors have decades of experience at publications such as The New York Times, The Wall Street Journal, Forbes and Reuters. Their relationships and expertise mean we get scoops more quickly than some of the bigger players.',
    ],
    imageUrl: EXCLUSIVE_REPORTING_IMAGE_URL,
  },
  {
    title: 'Insights Worth Your Time',
    paragraphs: [
      'Our subscribers are busy leaders, so we only publish reporting that’s different from anything you’ll read anywhere else, whether it’s details on venture capital strategy or a deep-dive investigation into fintech’s impact on the banking world.',
      'Our daily newsletters bring you the highlights from our reporting and across the industry, making it easier than ever for you to make informed, strategic decisions.',
    ],
    imageUrl: NEWSLETTERS_IMAGE_URL,
  },
  {
    title: 'Charts and Data Library',
    paragraphs: [
      'Search across our entire charts library—whether they’re looking for data tied to OpenAI, crypto markets or a single company embedded in a larger analysis. Each chart appears on its own page, credited to its author and linked directly to the article where it appeared, making it easier to move from data to context.',
    ],
    imageUrl: CHARTS_AND_DATA_LIBRARY_IMAGE_URL,
  },
];
